import { useTranslation } from 'react-i18next';
import CardPriceBox from './CardPriceBox';

export const CardHeader = ({
	image,
	title,
	monitoringType,
	phases,
	price,
	payment_status,
	duration,
	invoice_url,
	f100 = '',
	isCompleted,
}: any) => {
	const { t } = useTranslation();

	return (
		<div className="flex items-center justify-between gap-4 p-4 max-xxs:flex-col flex-row">
			<div className="flex flex-row gap-4">
				<img src={image} alt={title} className="w-16 h-16 rounded-lg object-cover shadow-md" />
				<div>
					<h2 className="font-bold text-base text-dark">{title}</h2>
					<span className="text-primary font-bold text-base underline">{monitoringType}</span>
					{duration && (
						<p className="text-light-grey text-sm">
							{`${t('duration')}: ${duration} ${t('year')}`}
						</p>
					)}
					<p className="text-light-grey text-sm">
						{!isCompleted ? `${phases} ${t('phase')}` : t('completed')}
					</p>
				</div>
			</div>
			<div className="flex items-center flex-col gap-2 max-xsm:items-start w-full">
				<CardPriceBox payment_status={payment_status} price={price} invoice_url={invoice_url} />
				{f100 && (
					<a
						href={f100}
						target="_blank"
						rel="noopener noreferrer"
						className="w-full text-right pt-4"
					>
						<span className="text-[#343A40] font-bold text-base underline cursor-pointer">
							F-100
						</span>
					</a>
				)}
			</div>
		</div>
	);
};

export default CardHeader;
